<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col-8">
        <span class="display-4 col-12">
          {{ $t("COMMON.PURCHASES_DELIVERIES") }}
        </span>
      </div>
    </div>

    <purchases-delivery-list-table :filterPurchasesOrder="purchasesOrder.id" />
  </div>
</template>

<script>
import formMixin from "@/mixins/form-mixin";
import PurchasesDeliveryListTable from "../../PurchasesDeliveryManagement/partials/PurchasesDeliveryListTable.vue";

export default {
  name: "purchases-order-view-deliveries",

  components: {
    PurchasesDeliveryListTable,
  },

  mixins: [formMixin],

  props: ["purchasesOrder"],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {},
};
</script>
<style scoped>
.delivery-item-name {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
